import { useInvoiceSetting } from "@/api/services/main/organization/invoice-setting";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { InvoiceSettingsForm } from "@/features/organization/invoice/components/InvoiceSettingsForm";
import { convertSettingToFormData } from "@/features/organization/invoice/utils/invoiceConverts";

/** 請求設定 tab — edit page (組織設定). */
export const InvoiceEditPage = () => {
  const { data, isLoading } = useInvoiceSetting();

  if (isLoading) return <LoadingPage />;
  if (!data?.data) return null;

  return <InvoiceSettingsForm defaultValues={convertSettingToFormData(data.data)} />;
};
